import { useState, useEffect, useCallback } from "react";
import { httpRequest } from "../../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../../ui-utils/apiConfig";
import { withStyles } from "@material-ui/core/styles";
import styles from "../OperationsStyles";
import {
  Typography,
  Button,
  Modal,
  MenuItem,
  Select,


  Grid,
  Box,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Tooltip

} from "@mui/material";
import { format } from "date-fns";
import dayjs from "dayjs";
import { DataGrid, GridCloseIcon } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Download, Edit } from "@mui/icons-material";
import Swal from "sweetalert2";
// import Filter from "../Filters/Fields";
import Filter from "../Filters/DDPIFields";

const DDPI = ({ classes }) => {
  const [ddpiData, setDdpiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0 });
  const [editModal, setEditModal] = useState(false);
  const [userData, setUserData] = useState({});
  const [stage, setStage] = useState("signed");
  const [checkboxToggle, setCheckboxToggle] = useState("signed");
  const [Fdate, setFdate] = useState(null);
  const [Tdate, setTdate] = useState(null);
  const [fterror, setFTError] = useState("");
  const [ddpiEnabledInXTS, setDdpiEnabledInXTS] = useState(false); // checkbox state
  const [requireXtsForApprove] = useState(true); // flip to false if you want to disable this checksite-wide


  
 const style = {
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "40% !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px !important",
    "@media only screen and (max-width: 1650px)": {
      width: "80% !important",
    },
  };

  const handleFDate = useCallback((newValue) => setFdate(dayjs(newValue).format("YYYY-MM-DD")), []);
  const handleTDate = useCallback((newValue) => setTdate(dayjs(newValue).format("YYYY-MM-DD")), []);

  useEffect(() => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    threeMonthsAgo.setDate(1);

    const fdate = threeMonthsAgo.toISOString().split("T")[0];
    const tdate = today.toISOString().split("T")[0];

      // Convert to Dayjs objects for the DatePicker
      // setFdate(dayjs(threeMonthsAgo));  // Set as Dayjs object
      // setTdate(dayjs(today));           // Set as Dayjs object

    fetchDdpiData({ fdate, tdate });
  }, []);

  const fetchDdpiData = async (payload) => {
    try {
      const response = await httpRequest({
        endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.ddpiList}`,
        method: "post",
        instance: "instanceOne",
        requestBody: payload,
      });
      console.log("fetchDdpiData", response?.ddpiRecords)
      if (response) {
        const allData = response?.ddpiRecords;
        const filtered = allData.filter((item) => item.stage === checkboxToggle);
        setDdpiData(allData);
        setFilteredData(filtered);
      }
    } catch (error) {
      console.error("Error fetching DDPI data:", error);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!Fdate || !Tdate) {
      setFTError("Both From Date and To Date are required *");
      return;
    }
    await fetchDdpiData({ fdate: Fdate, tdate: Tdate });
    setFTError("");
  };

  const handleReset = async () => {
    setFdate(null);
    setTdate(null);
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    threeMonthsAgo.setDate(1);
    await fetchDdpiData({
      fdate: threeMonthsAgo.toISOString().split("T")[0],
      tdate: today.toISOString().split("T")[0],
    });
  };

  const handlecheckboxChange = (e, str) => {
    setCheckboxToggle(str);
    const filtered = ddpiData.filter((item) => item.stage === str);
    setFilteredData(filtered);
  };

  const handleEditModal = (row) => {
    setEditModal(true);
    setUserData(row);
    // seed checkbox from row (adapt property name to your actual API)
  const seed =
    row?.ddpiEnabledInXTS ?? row?.xtsEnabled ?? false;
  setDdpiEnabledInXTS(Boolean(seed));
  };

  const handleClose = () => {
    setEditModal(false);
    setUserData({});
  };

  const handleSaveStatusChange = async (user) => {
    const userName = localStorage.getItem("username");
    const formattedDate = dayjs().format("YYYY-MM-DD");

    if (stage === "approved") {

      if (!user.firstparty_admin_signed || !user.secondparty_client_signed) {
       alert("Both parties are not signed yet in order to approve ...!")
        return; // STOP processing
      }

      try {
        const response = await httpRequest({
          endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.ddpiApprove}`,
          method: "post",
          instance: "instanceOne",
          requestBody: { client_id: user?.client_id, approvedBy: userName },
        });

        if (response) {
          Swal.fire({
            html: `<h2 style="font-size: 22px; font-family: 'cardiuma-regular' !important;">DDPI Approved Successfully for ${user.accountno}</h2>`,
            icon: "success",
          });

          handleReset();
          setEditModal(false);
        }
      } catch (error) {
        console.error("Error approving DDPI:", error);
      }
    }
  };

  const downloadDdpiDocument = async (filename,type,source) => {
  try { 

    let party
    if (type == "first_party_admin"){
      party = "first_party_admin"
    }else{
      party = "second_party_client"
    }
    const payload={filename,party,source}
    const response = await httpRequest({
      endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.ddpiDownload}`,
      method: "post",
      instance: "instanceOne",
      requestBody: payload,
    });

    console.log("ddpiDownloadRes", response);

    if (response.status === 200 && response?.data) {
      downloadPDF(response.data, response.filename);
    } else {
      window.alert("First party has not signed yet or no such key")
      console.error("Unexpected DDPI response structure:", response);
    }
  } catch (error) {
    console.log("errorrrr",error)
    if (error?.status === 404) {
      window.alert("First party has not signed yet or no such key")
      console.error("DDPI document not found (404)", error);
    } else {
      console.error("Error downloading DDPI document:", error);
    }
  }
};


  const downloadPDF = (base64Pdf, filename) => {
    const linkSource = `data:application/pdf;base64,${base64Pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = filename || "document.pdf";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const columns = [
    { field: "createdon", headerName: "Date", flex: 1, valueFormatter: (params) => format(new Date(params), "yyyy-MM-dd") },
    { field: "client_id", headerName: "Client ID", flex: 1 },
    { field: "client_name", headerName: "Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "mobile", headerName: "Mobile", flex: 1 },
    { field: "source", headerName: "Source", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <IconButton onClick={() => handleEditModal(params.row)}>
          <Edit />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      {/* Filters */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       {/* Date Filter Form */}
            <form className={classes.fnoFormDateField} onSubmit={handleFormSubmit} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="From"
                        format="DD-MM-YYYY"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ className: classes.input }}
                        className={classes.datePicker}
                        value={Fdate}
                        onChange={handleFDate}
                    />
                    <DatePicker
                        label="To"
                        format="DD-MM-YYYY"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ className: classes.input }}
                        className={classes.datePicker}
                        value={Tdate}
                        onChange={handleTDate}
                    />
                </LocalizationProvider>

          <Button type="submit" style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Submit</Button>

          <Button onClick={handleReset} style={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Reset</Button>

          </form>

        <Filter setHide={() => {}} checkboxToggle={checkboxToggle} handlecheckboxChange={handlecheckboxChange} setStatus={() => {}} />
      </Box>

      {fterror && <Typography color="error">{fterror}</Typography>}

          <Paper
              className={classes.horizantalTablayout}
              sx={{ height: "80vh" }}
          >
              <DataGrid
                  rows={filteredData}
                  columns={columns}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  pageSizeOptions={[10, 25, 50]}
                  className={classes.customDataGrid}
                  sx={{
                      "--DataGrid-containerBackground": "#131E2E",
                      "--DataGrid-rowBorderColor": "#000",
                      border: 0,
                      width: "100% !important",
                  }}
                  pagination
                  getRowId={(row) => row.id}
              />
          </Paper>

      {/* Modal */}
          <Modal
              open={editModal}
              onClose={handleClose}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
              userData={userData}
          >
              <Box
                  sx={{
                      ...style,
                      padding: "20px",
              
                  }}
              >
                  {/* Header */}
                  <Box
                      sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          width: "100%",
                          position: "relative",
                      }}
                  >
                      <Typography
                          id="modal-title"
                          variant="h6"
                          component="h2"
                          sx={{
                              fontFamily: "cardiuma-M",
                              fontWeight: "bold",
                          }}
                      >
                          DDPI Details
                      </Typography>

                      {/* Close Button */}
                      <Button
                          onClick={handleClose}
                          sx={{
                              minWidth: "unset",
                              padding: "0",
                              position: "absolute",
                              right: 0,
                              top: 0,
                          }}
                      >
                          <GridCloseIcon style={{ color: "red" }} />
                      </Button>
                  </Box>

                  {/* Content */}
          <Grid
            container
            sx={{
              paddingTop: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[
              {
                label: "Client ID", value: userData.client_id},
              { label: "Email", value: userData.email },
              { label: "Mobile", value: userData.mobile },
              // <-- only addition: conditional spread that inserts the eSign link object when signed
              ...(checkboxToggle === "signed" && userData.firstparty_admin_esignlink
                ? [
                  {
                    label: "First Party eSign Link",
                    value: (
                      <Typography
                        sx={{
                          fontFamily: "cardiuma-regular",
                          color: "#42a0f7",
                          textDecoration: "underline",
                          cursor: "pointer",
                          overflowWrap: "anywhere",
                        }}
                        onClick={() => window.open(userData?.firstparty_admin_esignlink, "_blank")}
                      >
                        {userData.firstparty_admin_esignlink ? "Open eSign Link" : "No link available"}
                      </Typography>
                    ),
                  },
                ]
                : []),

              ...(userData.firstparty_admin_filename ? [{
                label: "First Party eStamp PDF",
                value: (
                  <Tooltip title={`${userData?.firstparty_admin_filename}` || "No document"} arrow>
                    <Download
                      onClick={() => downloadDdpiDocument(userData?.firstparty_admin_filename, "first_party_admin", userData?.source)} // or your specific function
                      sx={{
                        color: "#42a0f7",
                        cursor: "pointer",
                        "&:hover": { color: "#1e88e5" },
                      }}
                    />
                  </Tooltip>
                ),
              }] :[]),
             
              {
                label: userData.firstparty_admin_filename ? "Second Party eStamp PDF" : "eStamp PDF",
                value: (
                  <Tooltip title={`${userData?.secondparty_client_filename}` || "No document"} arrow>
                  <Download
                      onClick={() => downloadDdpiDocument(userData?.secondparty_client_filename, "second_party_client", userData?.source
)} // if this is DDPI or another document
                    sx={{
                      color: "#42a0f7",
                      cursor: "pointer",
                      "&:hover": { color: "#1e88e5" },
                    }}
                  />
                  </Tooltip>
                ),
              },
              { label: "Stage", value: userData.stage ==='signed' ? "pending" : userData.stage},
              {
                label: "firstpartysigned", value: userData.firstparty_admin_signed ? "Yes" : "No" },
              { label: "secondpartysigned", value: userData.secondparty_client_signed ? "Yes" : "No"},
            ]
              .map((item, index) => (
                <Grid container key={index} sx={{ marginBottom: "16px" }}>
                  <Grid
                    item
                    lg={4}
                    sx={{
                      textAlign: "right",
                      paddingRight: "20px",
                      fontWeight: "bold",
                      fontFamily: "cardiuma-M",
                      paddingLeft: "20px",
                    }}
                  >
                    <Typography sx={{ fontFamily: "cardiuma-M" }}>
                      {item.label}:
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    lg={8}
                    sx={{
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap",
                      paddingLeft: "20px",
                    }}
                  >
                    {typeof item.value === "string" ||
                      typeof item.value === "number" ? (
                      <Typography sx={{ fontFamily: "cardiuma-regular" }}>
                        {item.value || "\u00A0"}
                      </Typography>
                    ) : (
                      item.value
                    )}
                  </Grid>
                </Grid>
              ))}

            {/* Stage Select (Editable) */}
            <Grid container sx={{ marginBottom: "16px" }}>
              <Grid
                item
                lg={4}
                sx={{
                  textAlign: "right",
                  paddingRight: "20px",
                  fontWeight: "bold",
                  fontFamily: "cardiuma-M",
                  paddingLeft: "20px",
                }}
              >
                <Typography sx={{ fontFamily: "cardiuma-M" }}>Stage:</Typography>
              </Grid>

              <Grid item lg={8} sx={{ paddingLeft: "20px" }}>
                <FormControl size="small" sx={{ width: "50%" }}>
                  <InputLabel shrink={true}>Stage</InputLabel>
                  <Select
                    value={userData.stage || ""}
                    onChange={(e) => {
                      setUserData((prev) => ({ ...prev, stage: e.target.value }));
                      setStage(e.target.value);
                    }}
                  >
                    <MenuItem value="signed">Pending</MenuItem>
                    <MenuItem value="approved">Approve</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            {/* DDPI Enabled in XTS Checkbox */}
            {checkboxToggle === "signed" && <Grid container sx={{ marginBottom: "16px" }}>
              <Grid
                item
                lg={4}
                sx={{
                  textAlign: "right",
                  paddingRight: "20px",
                  fontWeight: "bold",
                  fontFamily: "cardiuma-M",
                  paddingLeft: "20px",
                }}
              >
                <Typography sx={{ fontFamily: "cardiuma-M" }}>
                  DDPI Enabled in XTS:
                </Typography>
              </Grid>

              <Grid item lg={8} sx={{ paddingLeft: "20px", display: "flex", alignItems: "center" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={ddpiEnabledInXTS}
                      onChange={(e) => setDdpiEnabledInXTS(e.target.checked)}
                      size="medium"
                    />
                  }
                  label={<Typography sx={{ fontFamily: "cardiuma-regular" }}>Enabled</Typography>}
                />
              </Grid>
            </Grid>}

          </Grid>

                  {/* Save Button */}
          {checkboxToggle === "signed" && (
            <Grid
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "50px",
                paddingBottom: "10px",
              }}
            >
              <Button
                onClick={() => handleSaveStatusChange(userData)}
                sx={{
                  fontFamily: "cardiuma-regular",
                  color: "#ffffff",
                  background: "#F44748",
                  width: "80px",
                  height: "35px",
                  "&:hover": {
                    background: "#F44748",
                  },
                  "&.Mui-disabled": {
                    background: "#D3D3D3",
                    color: "#ffffff",
                  },
                }}
                disabled={
                  userData.stage === "signed" ||
                  (stage === "approved" && requireXtsForApprove && !ddpiEnabledInXTS)
                }
              >
                Save
              </Button>
            </Grid>
          )}

              </Box>
          </Modal>

    </>
  );
};

export default withStyles(styles)(DDPI);
